
import React from 'react'
import { useAppSelector } from '../../../hooks/redux'
import { type RootState } from '../../../store/store'
import { generateDefaultValueFormField } from '../../../functions/agent/AgentModals'
import { regExps } from '../../../constants'
import DefaultInput from '../../../app/custom/inputs/DefaultInput'
import CustomSelect from '../../../app/custom/selects/CustomSelect'
import GroupInput from '../../../app/custom/inputs/GroupInput'
import StateMarketingTypeUnit from './StateMarketingTypeUnit'
import CustomMultipleImagesInput from '../../../app/custom/inputs/CustomMultipleImagesInput'
import AreaInput from '../../../app/custom/inputs/AreaInput'
export default function MarketingFieldsUnit({
    setValue,
    errors,
    register,
    control,
    unitID, objectID,
    getValues, modal
}: any): JSX.Element {
    const modalID = modal?.[0]?.id
    const units = useAppSelector((state: RootState) => state.units.units)
    const newPropertyFields = useAppSelector((state: RootState) => state.property.newPropertyFields)
    const config = useAppSelector((state: RootState) => state.app.config)
    const currentUnit = units?.filter((el: any) => el.id === Number(unitID))[0]
    const marketingData = currentUnit?.attributes?.Marketing
    const propertyData = currentUnit?.attributes?.Property?.data
    const isDisabled = false // modalID === "save_after_draft_agent_unit"




    const rowImages = {
        id: 'Images',
        content: ['Set unit images'],
        element: 'input-images-multiple',
        ...(generateDefaultValueFormField(currentUnit?.attributes?.Images))
    }
    const rowHeadline = {
        id: 'Marketing.Headline',
        content: ['Marketing headline', 'This title will be seen by app users'],
        element: 'input', disabled: isDisabled, required: true,
        ...(generateDefaultValueFormField(marketingData?.Headline)), maxLength: 160
    }
    const rowDescription = {
        id: 'Marketing.Description',
        content: ['Marketing description', 'This unit\'s description will be seen by app users'],
        element: 'textarea', required: false,
        ...(generateDefaultValueFormField(marketingData?.Description)), maxLength: 15000
    }
    const rowPrice = {
        id: 'Marketing.Price',
        content: ['Price', 'AED', 'Input property price'],
        element: 'input-group', required: true,
        ...(generateDefaultValueFormField(marketingData?.Price)), regexp: regExps.isNumber
    }





    return (
        <>
            <div className="text-center py-4 my-2">
                <h1 className="text-dark m-0 fs-3">
                    Marketing info fields
                </h1>
            </div>
            <CustomMultipleImagesInput register={register} control={control} errors={errors} row={rowImages} getValues={getValues} />
            <DefaultInput row={rowHeadline} register={register} errors={errors} setValue={setValue} />
            <AreaInput register={register} errors={errors} row={rowDescription} />
            <GroupInput register={register} errors={errors} row={rowPrice} setValue={setValue} />
            <div className="fv-row my-2 py-2 w-100 fv-plugins-icon-container">
                <StateMarketingTypeUnit setValue={setValue} errors={errors} register={register} control={control} />
            </div>
        </>
    )
}
